import { Outlet } from 'react-router-dom';

export const EmailLayout = () => {
  return <Outlet />;
};
